import { render, staticRenderFns } from "./MyAsset.vue?vue&type=template&id=12fb9d12"
import script from "./MyAsset.vue?vue&type=script&lang=js"
export * from "./MyAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports